enum SecondaryIdType{
    mobilePhone = "secondaryAuth.phoneNumber",
    email = "secondaryAuth.email"
}

export default SecondaryIdType;